import { PageType, Section } from '@domain-group/fe-co-allhomes-ads';
var getAdTargeting = () => {
  var _category$subCategory, _category$primaryCate;
  if (typeof window === 'undefined') {
    // Only works client side
    return null;
  }
  var digitalData = window.digitalData || {};
  var _digitalData$page = digitalData.page,
    page = _digitalData$page === void 0 ? {} : _digitalData$page;
  var _page$category = page.category,
    category = _page$category === void 0 ? {} : _page$category;
  var getSection = () => {
    if (category.primaryCategory === 'Rent') {
      return Section.Rent;
    }
    if (category.primaryCategory === 'Developments') {
      return Section.NewHomes;
    }
    return Section.Buy;
  };
  var config = {
    pageType: PageType.Homepage,
    section: getSection()
  };
  var data = {
    cat: (_category$subCategory = category.subCategory2) === null || _category$subCategory === void 0 ? void 0 : _category$subCategory.toLowerCase(),
    cat1: (_category$primaryCate = category.primaryCategory) === null || _category$primaryCate === void 0 ? void 0 : _category$primaryCate.toLowerCase(),
    ctype: 'Homepage'
  };
  return {
    config,
    data
  };
};
export default getAdTargeting;